import css from "./AuthForm.module.css";

import { useState } from "react";
import { Input } from "./Input";
import { Button } from "../ui/Button";
import { useRealm, useT } from "~/util/Lang";
import { callApi } from "~/util/Loaders";
import { registerApi } from "~/routes/__site/api/register";
import { DiscordUser } from "~/util/auth";

export function DiscordRegister(props: { discordUser: DiscordUser }) {
  const { discordUser } = props;
  const [login, setLogin] = useState("");
  const [errors, setErrors] = useState<{ login?: string }>({});
  const realm = useRealm();
  const t = useT();
  return (
    <div className={css.root}>
      <div className={css.wrapper}>
        <h2>Register</h2>
        <div className={css.warning}>
          {t({
            en: "An account with similar details already exists in our system. If you already have an account, please log in and link your Discord from your profile settings. If not, please provide the required information below to continue with the registration.",
            ru: "Учетная запись с похожими данными уже существует в нашей системе. Если у вас уже есть аккаунт, пожалуйста, войдите и привяжите Discord в настройках профиля. Если аккаунта нет — укажите необходимые данные ниже, чтобы продолжить регистрацию.",
          })}
        </div>
        <form
          className={css.form}
          onSubmit={async (e) => {
            e.preventDefault();
            const newErrors: typeof errors = {};

            if (!login.trim()) newErrors.login = "Login is required.";

            if (Object.keys(newErrors).length > 0) {
              setErrors(newErrors);
              return;
            }

            // Если валидация прошла — регистрируем
            setErrors({});

            const res = await callApi(registerApi, {
              input: { login, discordUser },
              realm,
            });

            if (res.t === "error" && res.field === "login") {
              setErrors({ login: res.message });
            }
          }}
        >
          <Input
            label="Login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            autoFocus
            required={true}
            error={errors.login}
          />
          <Button type="submit">Register</Button>
        </form>
      </div>
    </div>
  );
}
